require('./innersvg.js')

var context = require.context('../assets', true, /\.(svg)$/);
var files = {};
context.keys().forEach((filename) => {
  files[filename.replace(/^\.\//, '')] = context(filename);
});

export default {
  name: 'svgicon',
  props: ['path', 'clazz'],
  data() {
    return {
      svg: undefined
    }
  },
  created() {
    let path = files[this.path] || this.path;
    fetch(path)
      .then(res => {
        if (res.status >= 200 && res.status < 300) {
          return res.text()
        } else {
          return undefined;
        }
      }).then(svg => {
        if (svg) this.svg = svg
      })
  },
  render(h) {
    if (this.svg === undefined) {
      return h('svg', {
        'class': this.clazz,
        attrs: {
          'xmlns': 'http://www.w3.org/2000/svg'
        }
      })
    } else {
      let parser = new DOMParser()
      let e = parser.parseFromString(this.svg, 'image/svg+xml').querySelector('svg')
      let attr = {}

      for (let i = 0; i < e.attributes.length; i++) {
        let a = e.attributes.item(i)
        attr[a.name] = a.value
      }

      return h('svg', {
        attrs: attr,
        'class': this.clazz,
        domProps: {
          innerHTML: e.innerHTML
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./theme/_base/js/SvgIcon.vue.js